import { render, staticRenderFns } from "./ConfigurationHeaderContainer.vue?vue&type=template&id=41736867&scoped=true"
import script from "./ConfigurationHeaderContainer.vue?vue&type=script&lang=js"
export * from "./ConfigurationHeaderContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41736867",
  null
  
)

export default component.exports